import DealRoomCreationRouter from './DealRoomCreation.router';

export { default as dealRoomRoutes } from './routes';

export default DealRoomCreationRouter;
